module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Regular-7ed21dab8e0fecde6da3a24ee5c5c459.ttf";